import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  getRequiredColumns,
  type ImportedScheduledRow,
  mapScheduleRow,
  type ScheduleImportError,
  validators,
} from '@/App/tiles/shared/import/accuSchedule.ts';
import { Import } from '@/App/tiles/shared/import/Import.tsx';
import type { TargetAccuType } from '@/store/targetAccumulator/state.ts';

type ImportScheduleProps = {
  accuType: TargetAccuType | 'Permanent' | 'Standard';
  onImportSchedule: (
    rows: readonly ImportedScheduledRow[],
    accuType: TargetAccuType | 'Permanent' | 'Standard',
  ) => Promise<void>;
  shouldShowConfirmation: boolean;
};

const ImportSchedule = ({ accuType, onImportSchedule, shouldShowConfirmation }: ImportScheduleProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-link btn-text-icon me-1"
        data-e2e="scheduler-importSchedule"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <FormattedMessage id="accumulator.scheduler.import" />
        <i className="ms-1 icon icon-sm">upload_file</i>
      </button>
      <Import<ImportedScheduledRow, ScheduleImportError>
        tradeType="TargetAccumulator"
        mapRowWith={({ cleanupNumber, sanitizeDate }) => mapScheduleRow({ cleanupNumber, sanitizeDate, accuType })}
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        validators={validators}
        requiredColumns={getRequiredColumns(accuType)}
        onImport={(rows) => onImportSchedule(rows, accuType ?? 'TargetAccu')}
        accuType={accuType}
        isEmpty={!shouldShowConfirmation}
      />
    </>
  );
};

export default ImportSchedule;
